/*
 * @Author: Fan
 * @Date: 2020-04-18 21:35:10
 * @description:
 * @LastEditors: Fan
 */
export class StyleControlOptions {
    constructor() {
        /**
         * 控件名称
         */
        this.name = "";
        /**
         * 多语言
         */
        this.name_i18n = null;
        /**
         * 是否可见
         */
        this.visible = true;
        /**
         * 控件样式
         */
        this.style = null;
        /**
         * tip提示
         */
        this.tips = "";
    }
}
export class EditableControlOptions extends StyleControlOptions {
    constructor() {
        super(...arguments);
        /**
         * 显示条件
         */
        this.displayFormula = "";
        /**
         * 变更事件
         */
        this.onChange = null;
    }
}
export class InputControlOptions extends EditableControlOptions {
    constructor() {
        super(...arguments);
        /**
         * 必填条件
         */
        this.requiredFormula = "";
        /**
         * 是否只读
         */
        this.readonlyFormula = false;
    }
}
/**
 * 数字格式化类型
 */
export var NumberFormatType;
(function (NumberFormatType) {
    /**
     * 空
     */
    NumberFormatType["None"] = "none";
    /**
     * 整数 200
     */
    NumberFormatType["Int"] = "integer";
    /**
     * 十分位 2,000.0
     */
    NumberFormatType["Tenths"] = "tenths";
    /**
     * 两位小数点 2,000.00
     */
    NumberFormatType["Decimal"] = "percentile";
    /**
     * 三位小数点 2,000.000
     */
    NumberFormatType["Decimal2"] = "Millimeter";
    /**
     * 四位小数点 2,000.0000
     */
    NumberFormatType["Decimal3"] = "tenThousand";
    /**
     * 百分比 20%
     */
    NumberFormatType["Ratio"] = "ratio";
    /**
     * 百分比单小数点 20.0%
     */
    NumberFormatType["Ratio2"] = "ratio.tenths";
    /**
     * 百分比双小数点 20.00%
     */
    NumberFormatType["Ratio3"] = "ratio.percentile";
    /**
     * 百分比三个小数点 20.000%
     */
    NumberFormatType["Ratio4"] = "ratio.Millimeter";
    /**
     * 百分比四个小数点 20.0000%
     */
    NumberFormatType["Ratio5"] = "ratio.tenThousand";
    /**
     * 货币-人民币 ￥2,000.00
     */
    NumberFormatType["CurrencyRMB"] = "RMB.percentile";
    /**
     * 货币-人民币 ￥2,000.000
     */
    NumberFormatType["CurrencyRMB2"] = "RMB.Millimeter";
    /**
     * 货币-人民币 ￥2,000.0000
     */
    NumberFormatType["CurrencyRMB3"] = "RMB.tenThousand";
    /**
     * 货币-美元 $2,000.00
     */
    NumberFormatType["CurrencyDollar"] = "dollar.percentile";
    /**
     * 货币-美元 $2,000.000
     */
    NumberFormatType["CurrencyDollar2"] = "dollar.Millimeter";
    /**
     * 货币-美元 $2,000.0000
     */
    NumberFormatType["CurrencyDollar3"] = "dollar.tenThousand";
    /**
     * 货币-欧元 €2,000.00
     */
    NumberFormatType["CurrencyEuro"] = "euro.percentile";
    NumberFormatType["CurrencyEuro2"] = "euro.Millimeter";
    NumberFormatType["CurrencyEuro3"] = "euro.tenThousand";
    /**
     * 货币-港币 HK$2,000.00
     */
    NumberFormatType["CurrencyHK"] = "HK.percentile";
    NumberFormatType["CurrencyHK2"] = "HK.Millimeter";
    NumberFormatType["CurrencyHK3"] = "HK.tenThousand";
})(NumberFormatType || (NumberFormatType = {}));
export var DateValueType;
(function (DateValueType) {
    /**
     * 空
     */
    DateValueType["None"] = "none";
    /**
     * 当前时间
     */
    DateValueType["Current"] = "current";
    /**
     *  使用数据项的默认值
     */
    DateValueType["DataItemDefault"] = "dataItemDefault";
})(DateValueType || (DateValueType = {}));
export var LocationType;
(function (LocationType) {
    LocationType["Area"] = "pp-cc-aa";
    LocationType["City"] = "pp-cc";
    LocationType["Province"] = "pp";
})(LocationType || (LocationType = {}));
export var TextAreaType;
(function (TextAreaType) {
    TextAreaType["LongText"] = "longText";
    TextAreaType["Editor"] = "Editor";
})(TextAreaType || (TextAreaType = {}));
